/**
 * Plays a short notification ping sound.
 * Rate-limited. No-op if suppressed by document visibility + OS grant.
 */

const SOUND_URL = '/sounds/notification-ping.mp3';
const RATE_LIMIT_MS = 5000;

let lastPlayedAt = 0;
let audio: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement {
  if (audio === null) {
    audio = new Audio(SOUND_URL);
    audio.preload = 'auto';
  }
  return audio;
}

export interface PlayOptions {
  /**
   * If true AND document is hidden, suppress the sound.
   * Used when OS notifications are granted — they'll provide their own sound.
   */
  suppressWhenHiddenAndOsGranted?: boolean;
}

export function play(options: PlayOptions = {}): void {
  const now = Date.now();
  if (now - lastPlayedAt < RATE_LIMIT_MS) return;

  if (typeof document !== 'undefined' && document.hidden && options.suppressWhenHiddenAndOsGranted) {
    return;
  }

  const a = getAudio();
  a.currentTime = 0;
  a.play().catch(err => {
    console.warn('[notificationSound] play failed', err);
  });
  lastPlayedAt = now;
}

// Test helper
export function _resetNotificationSound(): void {
  lastPlayedAt = 0;
  audio = null;
}
